export default __webpack_public_path__ + "static/media/notification.49951f20.png";